import { render, staticRenderFns } from "./PreliminaryReportHCO.vue?vue&type=template&id=0e2cd0ba&"
import script from "./PreliminaryReportHCO.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryReportHCO.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports